/**
 * N6 AI - Main JavaScript
 * Only for demonstration purposes (mobile menu, scroll effects)
 */

(function() {
    'use strict';

    // ============================================
    // DOM ELEMENTS
    // ============================================
    const header = document.getElementById('header');
    const menuToggle = document.getElementById('menuToggle');
    const menuClose = document.getElementById('menuClose');
    const mobileMenu = document.getElementById('mobileMenu');
    const menuOverlay = document.getElementById('menuOverlay');
    const currentYearEl = document.getElementById('currentYear');

    // ============================================
    // MOBILE MENU
    // ============================================
    function openMobileMenu() {
        if (!mobileMenu || !menuOverlay) return;

        mobileMenu.classList.add('is-open');
        menuOverlay.classList.add('is-visible');
        document.body.classList.add('menu-open');

        if (menuToggle) {
            menuToggle.classList.add('is-active');
        }
    }

    function closeMobileMenu() {
        if (!mobileMenu || !menuOverlay) return;

        mobileMenu.classList.remove('is-open');
        menuOverlay.classList.remove('is-visible');
        document.body.classList.remove('menu-open');

        if (menuToggle) {
            menuToggle.classList.remove('is-active');
        }
    }

    // Event listeners for mobile menu
    if (menuToggle) {
        menuToggle.addEventListener('click', function(e) {
            e.preventDefault();
            if (mobileMenu.classList.contains('is-open')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }

    if (menuClose) {
        menuClose.addEventListener('click', function(e) {
            e.preventDefault();
            closeMobileMenu();
        });
    }

    if (menuOverlay) {
        menuOverlay.addEventListener('click', function() {
            closeMobileMenu();
        });
    }

    // Close menu on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });

    // Close menu on window resize to desktop
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (window.innerWidth >= 992 && mobileMenu && mobileMenu.classList.contains('is-open')) {
                closeMobileMenu();
            }
        }, 150);
    });

    // ============================================
    // HEADER SCROLL EFFECT
    // ============================================
    function handleHeaderScroll() {
        if (!header) return;

        if (window.scrollY > 50) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }

    window.addEventListener('scroll', handleHeaderScroll);

    // Initial check on page load
    handleHeaderScroll();

    // ============================================
    // CURRENT YEAR (Footer)
    // ============================================
    if (currentYearEl) {
        currentYearEl.textContent = new Date().getFullYear();
    }

    // ============================================
    // SMOOTH SCROLL FOR ANCHOR LINKS
    // ============================================
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');

            // Skip if it's just "#" or empty
            if (targetId === '#' || targetId === '') return;

            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                e.preventDefault();

                // Close mobile menu if open
                closeMobileMenu();

                // Scroll to target
                const headerHeight = header ? header.offsetHeight : 0;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // ============================================
    // ACTIVE NAV LINK BASED ON URL
    // ============================================
    function setActiveNavLink() {
        const currentPage = window.location.pathname.split('/').pop() || 'index.html';

        // Desktop nav
        document.querySelectorAll('.header__nav-link').forEach(function(link) {
            const linkPage = link.getAttribute('href');
            if (linkPage === currentPage) {
                link.classList.add('is-active');
            }
        });

        // Mobile nav
        document.querySelectorAll('.mobile-menu__nav-link').forEach(function(link) {
            const linkPage = link.getAttribute('href');
            if (linkPage === currentPage) {
                link.classList.add('is-active');
            }
        });
    }

    setActiveNavLink();

    // ============================================
    // AUTH PASSWORD TOGGLES
    // ============================================
    document.querySelectorAll('.auth-field__toggle').forEach(function(toggle, index) {
        var field = toggle.closest('.auth-field');
        if (!field) return;
        var input = field.querySelector('input');
        if (!input) return;

        toggle.setAttribute('aria-controls', input.id || ('auth-password-' + index));
        if (!input.id) input.id = 'auth-password-' + index;

        toggle.addEventListener('click', function() {
            var isPassword = input.type === 'password';
            input.type = isPassword ? 'text' : 'password';
            toggle.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
        });
    });

    // ============================================
    // CHAT WIDGET
    // ============================================
    var chatWidget = document.getElementById('chatWidget');
    if (chatWidget) {
        var chatToggleBtn = document.getElementById('chatToggleBtn');
        var chatCloseIcon = document.getElementById('chatCloseIcon');

        function openChat() {
            chatWidget.classList.add('is-open');
        }

        function closeChat() {
            chatWidget.classList.remove('is-open');
        }

        if (chatToggleBtn) {
            chatToggleBtn.addEventListener('click', function() {
                if (chatWidget.classList.contains('is-open')) {
                    closeChat();
                } else {
                    openChat();
                }
            });
        }

        if (chatCloseIcon) {
            chatCloseIcon.addEventListener('click', function() {
                closeChat();
            });
        }
    }

})();
